input[type=number]{width:50px;padding:0;height:inherit}input[type=text]{width:100%}.hide-pencil{pointer-events:none;opacity:0}
/*# sourceMappingURL=editable-input.component-YFJZRRJS.css.map */
